import webBackApi from '../../api/webBackApi';

export const getSidebarConfig = async (customerId) => {
  try {
    const response = await webBackApi.get(`/api/sidebar-config/${customerId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sidebar config:', error);
    throw error;
  }
};

export const saveSidebarConfig = async (customerId, buttons) => {
  try {
    const response = await webBackApi.put(`/api/sidebar-config/${customerId}`, { buttons });
    return response.data;
  } catch (error) {
    console.error('Error saving sidebar config:', error);
    throw error;
  }
};
